// Branding constants and the support-address rule, kept free of zod.
//
// schemas.ts builds its zod schemas at module top level, so importing ANY value
// from it — even one string constant — pulls the whole module and zod into the
// importer's chunk (the bundler cannot prove those calls side-effect free). The
// sign-in pages and the SPA shells need only these few values, so they live
// here and schemas.ts re-exports them unchanged: '@l2u/shared/schemas' keeps
// working for every existing caller, and the login path imports this module
// instead.

// Shown in email bodies and on the sign-in / locked / expired pages; NEVER a
// Reply-To. In the public branding blob because unauthenticated pages show it.
export const PLATFORM_SUPPORT_EMAIL = 'compliance@supplierclear.com';
// `| undefined` on each field because exactOptionalPropertyTypes is on: a zod
// `.optional()` field (and `Partial<Branding>`) infers `?: T | undefined`,
// which a bare `?: T` refuses.
export function supportEmailOf(
  branding:
    | { supportEmail?: string | null | undefined; emailFromAddress?: string | null | undefined }
    | null
    | undefined,
): string {
  return branding?.supportEmail || branding?.emailFromAddress || PLATFORM_SUPPORT_EMAIL;
}

export const COMPANY_INFO_LABEL_DEFAULTS = {
  contractorType: 'Contractor Type',
  teamRegion: 'Team Region',
  primaryContact: 'Primary Contact',
} as const;

export const NAV_LABEL_DEFAULTS = {
  company: 'Company',
  companies: 'Companies',
  driver: 'Driver',
  drivers: 'Drivers',
} as const;
export type NavLabelKey = keyof typeof NAV_LABEL_DEFAULTS;
